import { SET_APP_STATE, SET_CSRF_TOKEN } from 'Actions/app'

import { APP_STATES } from 'Src/constants'

const initialState = {
  state: APP_STATES.LOADING,
  csrfToken: null
}

const app = (state = initialState, action) => {
  const payload = action.payload
  switch (action.type) {
    case SET_APP_STATE:
      return {
        ...state,
        state: payload.state
      }

    case SET_CSRF_TOKEN:
      return {
        ...state,
        csrfToken: payload.token
      }

    default:
      return state
  }
}

export default app
